// extracted by mini-css-extract-plugin
module.exports = {"MenuBar":"MenuBar_MenuBar__VkWwd","MenuItems":"MenuBar_MenuItems__2DVKP","Item":"MenuBar_Item__38u_3","Icon":"MenuBar_Icon__114_O","MenuBarOpened":"MenuBar_MenuBarOpened__3g48V"};